export const iconFontAwesomeMedicalHealthPersonBreastfeeding = (
	<i className="fa-solid fa-person-breastfeeding"></i>
);
